import moment from 'moment';
import { getCurrentDate, getStartOfDay } from '../../time'
import { guid } from '../../utils';

export function castImputationForServerFormat(imputation, user) {
    return {
        lineId: imputation.id,
        date: getCurrentDate(true),
        empId: user.emp_id,
        activityTypeId: imputation.activity.id,
        startTime: imputation.date_start,
        endTime: imputation.date_end,
        input: imputation.business,
        gpsStopped: !imputation.gps,
        lineCreateDate: imputation.date,
        comment: imputation.commentary,
        latitude: imputation.gps ? (imputation.gps_coord !== undefined ? imputation.gps_coord.lat : undefined) : undefined,
        longitude: imputation.gps ? (imputation.gps_coord !== undefined ? imputation.gps_coord.lon : undefined) : undefined,
        address: imputation.gps_address
    };
}

export function castImputationForClientFormat(imputation, current_day, activity) {
    return {
        id: imputation.mobile_id,
        day_id: current_day.id,
        date: new Date(moment(moment.utc(imputation.create_date)).local()),
        date_start: new Date(moment(moment.utc(imputation.date_start)).local()),
        date_end: imputation.date_end ? new Date(moment(moment.utc(imputation.date_end)).local()) : null,
        activity: activity,
        business: imputation.employee_input,
        commentary: imputation.employee_comment,
        // work_order_detail: work_order_detail,
        gps: imputation.gps_stopped,
        gps_coord: {lat: imputation.latitude, lon: imputation.longitude},
        gps_address: imputation.address ? imputation.address : null,
        in_progress: !imputation.date_end,
        // date_modif: null
    };
}

export function buildImputation(day_id, date, date_start, date_end, activity, business, commentary, work_order_detail, gps, gps_coord, gps_address, in_progress) {
    return {
        id: guid(),
        day_id: day_id,
        date: date,
        date_start: date_start,
        date_end: date_end,
        activity: activity,
        business: business,
        commentary: commentary,
        work_order_detail: work_order_detail,
        gps: gps,
        gps_coord: gps_coord,
        gps_address: gps_address,
        in_progress: in_progress,
        date_modif: null
    };
}

export function buildEndDayImputation(day_id, date, date_start, activity, business, commentary, gps, gps_coord, gps_address) {
    let startOfImputation = new Date(date_start);
    let endOfImputation = new Date(startOfImputation);
    let endOfDay = new Date(startOfImputation);

    endOfDay.setHours(23);
    endOfDay.setMinutes(59);

    var differenceInMs = (endOfDay - startOfImputation);
    var differenceInMinutes = Math.round(((differenceInMs % 86400000) % 3600000) / 60000)//Berk date js..
    const commonDurationOfEndDayImputation = 15;
    let durationOfEndDayImputation = Math.min(differenceInMinutes, commonDurationOfEndDayImputation);

    if (durationOfEndDayImputation === 0) {
        //Code bien dégueu là.. Fermes les yeux
        //En fait on décalle l'activité de type fin de journée d'une minute parce que sinon ça voudrait dire
        //que le domicile est à 23h59. Ce n'est pas possible car une activité doit faire 1 minute
        //minimum et ça ferait une activité sur deux jours
        startOfImputation.setMinutes(startOfImputation.getMinutes() - 1);
        durationOfEndDayImputation = 1;
        //Si une activité existe sur cette plage horaire alors il y aura un message d'erreur de chevauchement ..
        //On ne peut rien faire de mieux ici
        //C'est bon tu peux réouvrir :D
    }

    endOfImputation.setMinutes(startOfImputation.getMinutes() + durationOfEndDayImputation);

    return {
        id: guid(),
        day_id: day_id,
        date: date,
        date_start: startOfImputation,
        date_end: endOfImputation,
        activity: activity,
        business: business,
        commentary: commentary,
        gps: gps,
        gps_coord: gps_coord,
        gps_address: gps_address,
        in_progress: false,
        date_modif: null
    };
}

//CopyForBetweenDay
export function cloneImputation(imputation, day) {
    return {
        id: guid(),
        day_id: day.id,
        business: imputation.business,
        activity: imputation.activity,
        commentary: imputation.commentary,
        date: imputation.date,
        date_start: getStartOfDay(day.date),
        date_end: null,
        date_modif: null,
        in_progress: true,
        gps: imputation.gps,
        gps_coord: imputation.gps_coord,
        gps_address: imputation.gps_address,
        intervention_data_ok: imputation.intervention_data_ok
    };
}
